import React, { useEffect, useState } from "react";

const STORAGE_KEY = "erp_last_shown_sw_version";

function UpdatePopup() {
    const [show, setShow] = useState(false);
    const [registration, setRegistration] = useState(null);

    useEffect(() => {
        const styleId = "erp-update-popup-styles";

        if (!document.getElementById(styleId)) {
            const style = document.createElement("style");
            style.id = styleId;
            style.innerHTML = `
                @keyframes erpSlideIn {
                    from {
                        opacity: 0;
                        transform: translateY(-12px) translateX(10px) scale(0.98);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0) translateX(0) scale(1);
                    }
                }

                @keyframes erpPulseGlow {
                    0% {
                        box-shadow: 0 14px 34px rgba(15, 23, 42, 0.12);
                    }
                    50% {
                        box-shadow: 0 18px 40px rgba(37, 99, 235, 0.16);
                    }
                    100% {
                        box-shadow: 0 14px 34px rgba(15, 23, 42, 0.12);
                    }
                }
            `;
            document.head.appendChild(style);
        }

        const handleUpdate = (event) => {
            const { version, registration } = event.detail || {};
            if (!version) return;

            const alreadyShownVersion = localStorage.getItem(STORAGE_KEY);
            if (alreadyShownVersion === version) return;

            setRegistration(registration || null);
            setShow(true);
            localStorage.setItem(STORAGE_KEY, version);
        };

        window.addEventListener("ERP_UPDATE_AVAILABLE", handleUpdate);

        return () => {
            window.removeEventListener("ERP_UPDATE_AVAILABLE", handleUpdate);
        };
    }, []);

    useEffect(() => {
        let refreshing = false;

        const onControllerChange = () => {
            if (refreshing) return;
            refreshing = true;
            console.log("[SW] controller changed -> reload once");
            window.location.reload();
        };

        navigator.serviceWorker?.addEventListener("controllerchange", onControllerChange);

        return () => {
            navigator.serviceWorker?.removeEventListener("controllerchange", onControllerChange);
        };
    }, []);
    const handleClose = () => {
        setShow(false);
    };

    const handleUpdateNow = () => {
        setShow(false);

        if (registration?.waiting) {
            console.log("[POPUP] sending SKIP_WAITING");
            registration.waiting.postMessage({ type: "SKIP_WAITING" });
        } else {
            console.log("[POPUP] no waiting SW, reloading directly");
            window.location.reload();
        }
    };

    if (!show) return null;

    return (
        <div style={styles.wrapper}>
            <div style={styles.popup}>
                <div style={styles.leftAccent}></div>

                <button style={styles.closeBtn} onClick={handleClose}>
                    ×
                </button>

                <div style={styles.content}>
                    <div style={styles.iconBox}>
                        <div style={styles.spark1}></div>
                        <div style={styles.spark2}></div>

                        <svg
                            width="40"
                            height="40"
                            viewBox="0 0 64 64"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <defs>
                                <linearGradient id="rocketBlue" x1="0" y1="0" x2="1" y2="1">
                                    <stop offset="0%" stopColor="#4f8cff" />
                                    <stop offset="100%" stopColor="#1d4ed8" />
                                </linearGradient>
                                <linearGradient id="rocketFire" x1="0" y1="0" x2="1" y2="1">
                                    <stop offset="0%" stopColor="#ffb347" />
                                    <stop offset="100%" stopColor="#ff5a36" />
                                </linearGradient>
                            </defs>

                            <g transform="rotate(-20 32 32)">
                                <path
                                    d="M39 10C48 12 53 20 53 29C53 40 45 48 34 50L27 43C29 32 37 18 39 10Z"
                                    fill="url(#rocketBlue)"
                                />
                                <path
                                    d="M25 26C30 19 36 14 39 10C42 16 42 27 39 36C37 42 31 47 25 49L17 41C19 35 21 30 25 26Z"
                                    fill="#ffffff"
                                    stroke="#dbeafe"
                                    strokeWidth="1.5"
                                />
                                <circle
                                    cx="33"
                                    cy="26"
                                    r="6.5"
                                    fill="#dbeafe"
                                    stroke="#3b82f6"
                                    strokeWidth="2.5"
                                />
                                <path
                                    d="M18 35L11 39L16 29L25 26L18 35Z"
                                    fill="#2563eb"
                                />
                                <path
                                    d="M29 50L24 57L23 46L31 39L29 50Z"
                                    fill="#2563eb"
                                />
                                <path
                                    d="M18 44C16 49 17 53 20 56C23 53 26 49 26 45C23 44 21 44 18 44Z"
                                    fill="url(#rocketFire)"
                                />
                            </g>
                        </svg>
                    </div>

                    <div style={styles.body}>
                        <div style={styles.title}>ERP Update</div>
                        <div style={styles.message}>
                            New update available. Refresh now.
                        </div>

                        <div style={styles.actions}>
                            <button style={styles.laterBtn} onClick={handleClose}>
                                <span style={styles.clockIcon}>↻</span>
                                Later
                            </button>

                            <button style={styles.updateBtn} onClick={handleUpdateNow}>
                                <span style={styles.updateIcon}>↻</span>
                                Update
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const styles = {
    wrapper: {
        position: "fixed",
        top: 16,
        right: 16,
        zIndex: 9999,
    },

    popup: {
        position: "relative",
        width: 360,              // was 540
        minHeight: 120,          // was 170
        background: "#ffffff",
        borderRadius: 18,
        border: "1px solid rgba(226,232,240,0.95)",
        boxShadow: "0 12px 28px rgba(15, 23, 42, 0.12)",
        overflow: "hidden",
        animation: "erpSlideIn 0.28s ease-out",
        fontFamily: "Inter, Arial, sans-serif",
    },

    leftAccent: {
        position: "absolute",
        left: 0,
        top: 0,
        bottom: 0,
        width: 4,
        background: "linear-gradient(180deg, #3b82f6, #2563eb, #1d4ed8)",
        borderTopLeftRadius: 18,
        borderBottomLeftRadius: 18,
    },

    closeBtn: {
        position: "absolute",
        top: 10,
        right: 10,
        width: 28,
        height: 28,
        border: "none",
        background: "transparent",
        color: "#94a3b8",
        fontSize: 20,
        cursor: "pointer",
        lineHeight: "28px",
        textAlign: "center",
        zIndex: 2,
    },

    content: {
        display: "flex",
        alignItems: "center",
        gap: 14,
        padding: "18px 18px 16px 20px",
    },

    iconBox: {
        position: "relative",
        width: 72,               // was 130
        height: 72,
        minWidth: 72,
        borderRadius: 18,
        background: "linear-gradient(180deg, #f4f8ff 0%, #edf4ff 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },

    spark1: {
        position: "absolute",
        top: 10,
        left: 14,
        width: 5,
        height: 5,
        borderRadius: "50%",
        background: "#93c5fd",
    },

    spark2: {
        position: "absolute",
        bottom: 12,
        right: 12,
        width: 6,
        height: 6,
        borderRadius: "50%",
        background: "#60a5fa",
    },

    body: {
        flex: 1,
        paddingRight: 8,
    },

    title: {
        fontSize: 18,            // was 34
        fontWeight: 700,
        color: "#0f172a",
        lineHeight: 1.2,
        marginBottom: 4,
    },

    message: {
        fontSize: 13,            // was 18
        color: "#64748b",
        lineHeight: 1.4,
        marginBottom: 14,
    },

    actions: {
        display: "flex",
        gap: 8,
    },

    laterBtn: {
        height: 36,              // was 56
        minWidth: 90,
        padding: "0 14px",
        borderRadius: 10,
        border: "1px solid #e2e8f0",
        background: "#ffffff",
        color: "#667085",
        fontSize: 13,
        fontWeight: 600,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 6,
    },

    updateBtn: {
        height: 36,              // was 56
        minWidth: 105,
        padding: "0 16px",
        borderRadius: 10,
        border: "none",
        background: "linear-gradient(135deg, #4f8cff 0%, #2563eb 45%, #4338ca 100%)",
        color: "#ffffff",
        fontSize: 13,
        fontWeight: 700,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 7,
        boxShadow: "0 8px 18px rgba(37, 99, 235, 0.22)",
    },

    clockIcon: {
        fontSize: 14,
        lineHeight: 1,
        color: "#94a3b8",
    },

    updateIcon: {
        fontSize: 15,
        lineHeight: 1,
        color: "#ffffff",
    },
};
export default UpdatePopup;